<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="800">
    <v-card>
      <ODialogBar title="Ajuste de Centro de Custo/Produto" @close="dismiss" />

      <v-card-text class="pa-3">
        <v-form
          ref="theForm"
          v-model="isValid"
          class="d-flex flex-wrap items-start"
        >
          <OAlert class="w-full ma-3" info>
            Esta operação vai editar cada registro selecionado e alterar seu
            Centro de Custo e Produto para os valores a seguir.

            <b>
              Apenas registros do tipo Instalação/Retirada/Intervenção são
              afetados.
            </b>
          </OAlert>

          <div class="w-full d-flex items-start">
            <OAutocomplete
              class="pa-3 w-1/2"
              v-model="costCenterId"
              label="Centro de Custo"
              placeholder="Selecione..."
              :items="costCenters"
              :rules="[isSet]"
            />

            <OSelect
              class="pa-3 w-1/2"
              label="Produto"
              v-model="productTypeId"
              :clearable="false"
              :items="ccProductTypes"
              :rules="[isSet]"
            />
          </div>
        </v-form>
      </v-card-text>
      <ODialogButtons class="pa-6" @cancel="dismiss" @apply="apply" />
    </v-card>
  </ODialog>
</template>

<script>
import TheUser from 'oderon-vue/auth/TheUser'
import { CostCenter, ClientHistory, go } from '../../../models'
import { isSet } from 'oderon-vue/utils.js'
import { splitAndSort, canEdit } from './operation-utils'

export default {
  code: 'ChangeCostCenter',
  label: 'Mudar Centro de Custo...',
  components: {},
  data() {
    let start = this.reset()
    return {
      ...start,
      isSet
    }
  },
  computed: {
    ccProductTypes() {
      let mkNull = (text) => [{ text, value: null, disabled: true }]

      if (this.costCenterId == null)
        return mkNull('(Escolha um centro de custo para ver seus produtos...)')

      let cc = this.costCenters.find((x) => x.id == this.costCenterId)
      if (cc == null || cc.productTypes == null || cc.productTypes.length < 1)
        return mkNull('Não existem produtos para o CC selecionado')

      let res = cc.productTypes
        .filter((x) => x.type == 'oderon_fox')
        .map((x) => {
          return { ...x, text: x.alias, value: x.id }
        })
      return res
    }
  },
  watch: {
    'row.costCenterId'() {
      // NB: Isto executa depois que a computed-prop
      // ccProductTypes foi atualizada.
      this.autofillProductType()
    }
  },
  methods: {
    reset() {
      return {
        isValid: false,
        costCenters: [],
        costCenterId: null,
        productTypeId: null,
        historyIds: []
      }
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    async open({ historyIds }) {
      if (!canEdit(TheUser)) {
        this.$snack(
          'Você não tem permissão para editar registros de histórico',
          { color: 'red' }
        )
        return null
      }

      Object.assign(this, this.reset())
      this.historyIds = historyIds

      if (this.$refs.theForm) this.$refs.theForm.resetValidation()

      this.$refs.dialog.$loading(() => this.fetchCostCenters())

      return this.$refs.dialog.$open()
    },

    async fetchCostCenters() {
      let items = await CostCenter.findAll({ includeInactive: true })
      this.costCenters = splitAndSort(items, { prefixToRemove: 'CC ' })
    },

    // Autofill do productTypeId quando o CC muda e só tem 1 produto
    // NB: Isto depende da computed-prop ccProductTypes.
    autofillProductType() {
      if (
        this.ccProductTypes.length == 1 &&
        this.ccProductTypes[0].id != null
      ) {
        this.productTypeId = this.ccProductTypes[0].id
        return true
      }
    },

    apply() {
      if (this.$refs.theForm.validate()) {
        this.$refs.dialog.$loading(async () => {
          let { costCenterId, productTypeId } = this
          for (let id of this.historyIds) {
            let old = await ClientHistory.findById(id)
            if (old.type == 'installation') {
              Object.assign(old, { costCenterId, productTypeId })
              let cid = old.clientId
              let prefix = old.subType // install, remove, intervention
              await go.patch(`/clients/${cid}/${prefix}/${old.id}`, old)
            }
          }
          this.$snack('Registros atualizados com sucesso')
          this.$refs.dialog.$apply('RELOAD')
        })
      }
    }
  }
}
</script>

<style></style>
